export { Details } from "./details";
